import { render, staticRenderFns } from "./divider-secondary.vue?vue&type=template&id=76e3b581&scoped=true"
import script from "./divider-secondary.vue?vue&type=script&lang=js"
export * from "./divider-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e3b581",
  null
  
)

export default component.exports